import { common } from '../../constants';
import { useTranslation } from 'react-i18next';
import * as S from './style';
import { Icon, Typography as T, Grid, Cards } from '../../components';
import { useCountryType } from '../../context/country-type';
import { countryType } from '../../constants/data-types';

const { Row, Col } = Grid;
const { Checklist } = Cards;

const StepQuestion = ({ step, checkUncheckItem, checkItem }) => {
  const { id: stepId, sections = [], stepOrder } = step;
  const { countryType: country } = useCountryType();
  const { t } = useTranslation();
  const questionNumber = 'Q' + (stepOrder - 1);

  const createKey = (index) => {
    const keys = ['A', 'B', 'C'];
    return `question${keys[index]}`;
  };

  return (
    <>
      {sections.map((section, sectionIndex) => (
        <Row mt="6" mtM="6" key={`section-${sectionIndex}`}>
          <Col w={[4, 12, 12]}>
            <S.SectionHeader mb="5">
              <Icon
                icon={'checklist2'}
                width={24}
                height={24}
                color={'primaryMain'}
                mr="2"
              />
              {country === countryType.GREAT_BRITAIN && (
                <T.P size="xl" weight="bold" color="neutralMain">
                  {questionNumber +
                    t(
                      `common.heading.${createKey(sectionIndex)}`,
                      common.heading[`${createKey(sectionIndex)}`]
                    )}
                </T.P>
              )}
              {country === countryType.SCOTLAND && (
                <T.P size="xl" weight="bold" color="neutralMain">
                  {t(section.title)}
                </T.P>
              )}
            </S.SectionHeader>
            <Row inner>
              {(Array.isArray(section.items) ? section.items : []).map(
                (item, itemIndex) => (
                  <Col w={[4, 12, 6]} key={itemIndex} isFirst={itemIndex === 0}>
                    <Checklist
                      completed={checkItem(sectionIndex, `sections`, itemIndex)}
                      handleChange={() =>
                        checkUncheckItem(
                          stepId,
                          sectionIndex,
                          'sections',
                          itemIndex
                        )
                      }
                      title={item.title}
                      description={item.description}
                      thisCanInclude={item.thisCanInclude}
                      tips={item.tips}
                      mb="4"
                    />
                  </Col>
                )
              )}
            </Row>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default StepQuestion;
